// Search utility functions for robust college search functionality

// College nicknames and common variations
const collegeAliases = {
  // MIT variations
  'mit': 'Massachusetts Institute of Technology',
  'massachusetts institute': 'Massachusetts Institute of Technology',
  'massachusetts tech': 'Massachusetts Institute of Technology',
  
  // Harvard variations
  'harvard': 'Harvard University',
  'harvard college': 'Harvard University',
  'harvard uni': 'Harvard University',
  
  // Stanford variations
  'stanford': 'Stanford University',
  'stanford uni': 'Stanford University',
  
  // Yale variations
  'yale': 'Yale University',
  'yale college': 'Yale University',
  
  // Caltech variations
  'caltech': 'California Institute of Technology',
  'california tech': 'California Institute of Technology',
  'california institute': 'California Institute of Technology',
  
  // Duke variations
  'duke': 'Duke University',
  'duke uni': 'Duke University',
  
  // Johns Hopkins variations
  'jhu': 'Johns Hopkins University',
  'johns hopkins': 'Johns Hopkins University',
  'hopkins': 'Johns Hopkins University',
  
  // Northwestern variations
  'northwestern': 'Northwestern University',
  'northwestern uni': 'Northwestern University',
  'nu': 'Northwestern University',
  
  // UPenn variations
  'upenn': 'University of Pennsylvania',
  'penn': 'University of Pennsylvania',
  'university of pennsylvania': 'University of Pennsylvania',
  'pennsylvania': 'University of Pennsylvania',
  
  // Cornell variations
  'cornell': 'Cornell University',
  'cornell uni': 'Cornell University',
  
  // UChicago variations
  'uchicago': 'University of Chicago',
  'university of chicago': 'University of Chicago',
  'chicago': 'University of Chicago',
  
  // Brown variations
  'brown': 'Brown University',
  'brown uni': 'Brown University',
  
  // Columbia variations
  'columbia': 'Columbia University',
  'columbia uni': 'Columbia University',
  'columbia university': 'Columbia University',
  'cu': 'Columbia University',
  
  // Dartmouth variations
  'dartmouth': 'Dartmouth College',
  'dartmouth college': 'Dartmouth College',
  
  // UCLA variations
  'ucla': 'University of California, Los Angeles',
  'university of california los angeles': 'University of California, Los Angeles',
  'university of california la': 'University of California, Los Angeles',
  
  // UC Berkeley variations
  'uc berkeley': 'University of California, Berkeley',
  'berkeley': 'University of California, Berkeley',
  'university of california berkeley': 'University of California, Berkeley',
  'cal': 'University of California, Berkeley',
  
  // Rice variations
  'rice': 'Rice University',
  'rice uni': 'Rice University',
  
  // Notre Dame variations
  'notre dame': 'University of Notre Dame',
  'university of notre dame': 'University of Notre Dame',
  'nd': 'University of Notre Dame',
  
  // Vanderbilt variations
  'vanderbilt': 'Vanderbilt University',
  'vandy': 'Vanderbilt University',
  'vanderbilt uni': 'Vanderbilt University',
  
  // CMU variations
  'cmu': 'Carnegie Mellon University',
  'carnegie mellon': 'Carnegie Mellon University',
  'carnegie mellon uni': 'Carnegie Mellon University',
  
  // USC variations
  'usc': 'University of Southern California',
  'university of southern california': 'University of Southern California',
  'southern california': 'University of Southern California',
  
  // UCSB variations
  'ucsb': 'University of California, Santa Barbara',
  'university of california santa barbara': 'University of California, Santa Barbara',
  'santa barbara': 'University of California, Santa Barbara',
  
  // UCSD variations
  'ucsd': 'University of California, San Diego',
  'university of california san diego': 'University of California, San Diego',
  'san diego': 'University of California, San Diego',
  
  // UCI variations
  'uci': 'University of California, Irvine',
  'university of california irvine': 'University of California, Irvine',
  'irvine': 'University of California, Irvine',
  
  // UCD variations
  'ucd': 'University of California, Davis',
  'university of california davis': 'University of California, Davis',
  'davis': 'University of California, Davis',
  
  // Georgia Tech variations
  'georgia tech': 'Georgia Institute of Technology',
  'georgia institute': 'Georgia Institute of Technology',
  'gatech': 'Georgia Institute of Technology',
  'gt': 'Georgia Institute of Technology',
  
  // UT Austin variations
  'ut austin': 'University of Texas at Austin',
  'university of texas austin': 'University of Texas at Austin',
  'utaustin': 'University of Texas at Austin',
  'utexas': 'University of Texas at Austin',
  
  // UW variations
  'uw': 'University of Washington',
  'university of washington': 'University of Washington',
  'washington': 'University of Washington',
  
  // UW Madison variations
  'uw madison': 'University of Wisconsin-Madison',
  'university of wisconsin madison': 'University of Wisconsin-Madison',
  'uwmadison': 'University of Wisconsin-Madison',
  'wisconsin': 'University of Wisconsin-Madison',
  
  // UIUC variations
  'uiuc': 'University of Illinois Urbana-Champaign',
  'university of illinois': 'University of Illinois Urbana-Champaign',
  'illinois': 'University of Illinois Urbana-Champaign',
  
  // Ohio State variations
  'ohio state': 'Ohio State University',
  'osu': 'Ohio State University',
  'buckeyes': 'Ohio State University',
  
  // Purdue variations
  'purdue': 'Purdue University',
  'purdue uni': 'Purdue University',
  
  // Texas A&M variations
  'texas a&m': 'Texas A&M University',
  'texas a and m': 'Texas A&M University',
  'tamu': 'Texas A&M University',
  'aggies': 'Texas A&M University',
  
  // Rutgers variations
  'rutgers': 'Rutgers University',
  'rutgers uni': 'Rutgers University',
  
  // UMD variations
  'umd': 'University of Maryland',
  'university of maryland': 'University of Maryland',
  'maryland': 'University of Maryland',
  
  // Rochester variations
  'rochester': 'University of Rochester',
  'university of rochester': 'University of Rochester',
  'urochester': 'University of Rochester',
  
  // Case Western variations
  'case western': 'Case Western Reserve University',
  'case western reserve': 'Case Western Reserve University',
  'case': 'Case Western Reserve University',
  'cwru': 'Case Western Reserve University',
};

// Common misspellings and typos
const commonMisspellings = {
  'harvard': ['harverd', 'harvardd', 'harvad', 'harvrd'],
  'stanford': ['stanfurd', 'stanfordd', 'stanfod', 'stanfrd'],
  'yale': ['yal', 'yalle', 'yalee', 'yal'],
  'mit': ['m.i.t', 'm.i.t.', 'mit.', 'm.i.t'],
  'berkeley': ['berkley', 'berkely', 'berklee', 'berkely'],
  'ucla': ['u.c.l.a', 'u.c.l.a.', 'ucla.', 'u.c.l.a'],
  'usc': ['u.s.c', 'u.s.c.', 'usc.', 'u.s.c'],
  'cornell': ['cornel', 'cornelll', 'cornel', 'cornel'],
  'duke': ['duk', 'duke', 'duke', 'duk'],
  'northwestern': ['northwestern', 'northwestern', 'northwestern', 'northwestern'],
  'penn': ['pen', 'penn', 'penn', 'pen'],
  'rice': ['ric', 'rice', 'rice', 'ric'],
  'vanderbilt': ['vanderbilt', 'vanderbilt', 'vanderbilt', 'vanderbilt'],
  'notre dame': ['notre dame', 'notre dame', 'notre dame', 'notre dame'],
  'georgia tech': ['georgia tech', 'georgia tech', 'georgia tech', 'georgia tech'],
  'texas a&m': ['texas a&m', 'texas a&m', 'texas a&m', 'texas a&m'],
};

// State abbreviations and full names
const stateMappings = {
  'ma': 'Massachusetts',
  'ny': 'New York',
  'ct': 'Connecticut',
  'nj': 'New Jersey',
  'pa': 'Pennsylvania',
  'ri': 'Rhode Island',
  'nh': 'New Hampshire',
  'md': 'Maryland',
  'ca': 'California',
  'wa': 'Washington',
  'il': 'Illinois',
  'in': 'Indiana',
  'wi': 'Wisconsin',
  'oh': 'Ohio',
  'mo': 'Missouri',
  'tx': 'Texas',
  'ga': 'Georgia',
  'nc': 'North Carolina',
  'va': 'Virginia',
  'tn': 'Tennessee',
  'fl': 'Florida',
  'mi': 'Michigan',
  'or': 'Oregon',
  'az': 'Arizona',
  'co': 'Colorado',
  'ut': 'Utah',
  'nv': 'Nevada',
  'id': 'Idaho',
  'mt': 'Montana',
  'wy': 'Wyoming',
  'nd': 'North Dakota',
  'sd': 'South Dakota',
  'ne': 'Nebraska',
  'ks': 'Kansas',
  'ok': 'Oklahoma',
  'ar': 'Arkansas',
  'la': 'Louisiana',
  'ms': 'Mississippi',
  'al': 'Alabama',
  'ky': 'Kentucky',
  'wv': 'West Virginia',
  'sc': 'South Carolina',
  'de': 'Delaware',
  'vt': 'Vermont',
  'me': 'Maine',
  'ak': 'Alaska',
  'hi': 'Hawaii',
};

// Levenshtein distance function for fuzzy matching
function levenshteinDistance(str1, str2) {
  const matrix = [];
  
  for (let i = 0; i <= str2.length; i++) {
    matrix[i] = [i];
  }
  
  for (let j = 0; j <= str1.length; j++) {
    matrix[0][j] = j;
  }
  
  for (let i = 1; i <= str2.length; i++) {
    for (let j = 1; j <= str1.length; j++) {
      if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }
  
  return matrix[str2.length][str1.length];
}

// Calculate similarity score between two strings
function calculateSimilarity(str1, str2) {
  const distance = levenshteinDistance(str1.toLowerCase(), str2.toLowerCase());
  const maxLength = Math.max(str1.length, str2.length);
  return 1 - (distance / maxLength);
}

// Normalize search query
function normalizeQuery(query) {
  return query.toLowerCase().trim().replace(/[^\w\s]/g, '');
}

// Check if query matches college name with fuzzy matching
function fuzzyMatch(query, collegeName, threshold = 0.7) {
  const normalizedQuery = normalizeQuery(query);
  const normalizedCollege = normalizeQuery(collegeName);
  
  // Exact match
  if (normalizedQuery === normalizedCollege) {
    return 1.0;
  }
  
  // Contains match
  if (normalizedCollege.includes(normalizedQuery) || normalizedQuery.includes(normalizedCollege)) {
    return 0.9;
  }
  
  // Word-by-word matching
  const queryWords = normalizedQuery.split(/\s+/);
  const collegeWords = normalizedCollege.split(/\s+/);
  
  let wordMatches = 0;
  for (const queryWord of queryWords) {
    for (const collegeWord of collegeWords) {
      if (calculateSimilarity(queryWord, collegeWord) >= threshold) {
        wordMatches++;
        break;
      }
    }
  }
  
  if (wordMatches > 0) {
    return 0.8 * (wordMatches / queryWords.length);
  }
  
  // Fuzzy matching
  const similarity = calculateSimilarity(normalizedQuery, normalizedCollege);
  return similarity >= threshold ? similarity : 0;
}

// Main search function
export function searchColleges(colleges, query) {
  if (!query || query.trim() === '') {
    return colleges;
  }
  
  const normalizedQuery = normalizeQuery(query);
  const results = [];
  
  for (const college of colleges) {
    let score = 0;
    let matchType = '';
    
    // Check for exact alias match
    if (collegeAliases[normalizedQuery] === college.name) {
      score = 1.0;
      matchType = 'exact_alias';
    }
    
    // Check for misspelling corrections
    for (const [correct, misspellings] of Object.entries(commonMisspellings)) {
      if (misspellings.includes(normalizedQuery) && 
          collegeAliases[correct] === college.name) {
        score = 0.95;
        matchType = 'misspelling_correction';
        break;
      }
    }
    
    // Check college name fuzzy matching
    const nameScore = fuzzyMatch(query, college.name);
    if (nameScore > score) {
      score = nameScore;
      matchType = 'fuzzy_name';
    }
    
    // Check location matching
    const location = college.location.toLowerCase();
    if (location.includes(normalizedQuery)) {
      const locationScore = 0.8;
      if (locationScore > score) {
        score = locationScore;
        matchType = 'location';
      }
    }
    
    // Check state abbreviations and full names
    const stateAbbr = Object.keys(stateMappings).find(abbr => 
      normalizedQuery.includes(abbr.toLowerCase())
    );
    if (stateAbbr && location.includes(stateMappings[stateAbbr].toLowerCase())) {
      const stateScore = 0.7;
      if (stateScore > score) {
        score = stateScore;
        matchType = 'state';
      }
    }
    
    // Check for partial word matches in college name
    const collegeWords = college.name.toLowerCase().split(/\s+/);
    for (const word of collegeWords) {
      if (word.length > 2 && normalizedQuery.includes(word)) {
        const partialScore = 0.6;
        if (partialScore > score) {
          score = partialScore;
          matchType = 'partial_word';
        }
      }
    }
    
    // Add to results if score meets threshold
    if (score >= 0.3) {
      results.push({
        college,
        score,
        matchType
      });
    }
  }
  
  // Sort by score (highest first) and return college objects
  return results
    .sort((a, b) => b.score - a.score)
    .map(result => result.college);
}

// Get search suggestions based on query
export function getSearchSuggestions(colleges, query, maxSuggestions = 5) {
  if (!query || query.trim() === '') {
    return [];
  }
  
  const normalizedQuery = normalizeQuery(query);
  const suggestions = new Set();
  
  // Add exact alias matches
  if (collegeAliases[normalizedQuery]) {
    suggestions.add(collegeAliases[normalizedQuery]);
  }
  
  // Add colleges that start with the query
  for (const college of colleges) {
    const normalizedName = normalizeQuery(college.name);
    if (normalizedName.startsWith(normalizedQuery) && suggestions.size < maxSuggestions) {
      suggestions.add(college.name);
    }
  }
  
  // Add location-based suggestions
  for (const college of colleges) {
    const location = college.location.toLowerCase();
    if (location.includes(normalizedQuery) && suggestions.size < maxSuggestions) {
      suggestions.add(college.name);
    }
  }
  
  return Array.from(suggestions).slice(0, maxSuggestions);
} 